var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15.6,
    viewBox: "0 0 15 15.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_lucchetto",
    "data-name": "icona lucchetto",
    transform: "translate(-54 -134.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icona_lucchetto-2",
    "data-name": "icona lucchetto",
    transform: "translate(55 135.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1864",
    "data-name": "Tracciato 1864",
    d: "M5.949,16.5H16.094a1.425,1.425,0,0,1,1.449,1.4v4.9a1.425,1.425,0,0,1-1.449,1.4H5.949A1.425,1.425,0,0,1,4.5,22.8V17.9a1.425,1.425,0,0,1,1.449-1.4Z",
    transform: "translate(-4.5 -10.2)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1865",
    "data-name": "Tracciato 1865",
    d: "M10.5,9.3V6.5a3.625,3.625,0,0,1,7.246,0V9.3",
    transform: "translate(-7.602 -3)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_789",
    "data-name": "Rettangolo 789",
    transform: "translate(54 135)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 14,
    height: 14,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.015c54a6663f9ed7cca6548ff4441232.svg";
export { ForwardRef as ReactComponent };